import React from "react";
import { TextField } from "@material-ui/core";
import { FieldAttributes, useField } from "formik";

type UploadTextFieldProps = {
  label: string;
  id?: string;
  outlined?: boolean;
  multiline?: boolean;
  lines?: number;
  maxLength?: number;
  autoFocus?: boolean;
} & FieldAttributes<{}>;

export const UploadTextField: React.FC<UploadTextFieldProps> = ({
  placeholder,
  label,
  id,
  type,
  outlined = false,
  multiline = false,
  lines = 5,
  autoFocus = false,
  ...props
}) => {
  const [field, meta] = useField<{}>(props);
  const errorText = meta.error && meta.touched ? meta.error : "";
  const idValue = id ? id : field.name;

  // build props for <input> inside TextField
  let inputProps = {};
  if (props.maxLength) inputProps = { maxLength: props.maxLength };
  if (props.autoComplete) inputProps = { autoComplete: props.autoComplete };
  if (props.className) inputProps = { className: props.className };

  // typescript-way to handle "variant" type
  const variantProps = outlined
    ? // or use const expression
      { variant: "outlined" as "outlined" }
    : { variant: "standard" as "standard" };

  return (
    <TextField
      label={label}
      id={idValue}
      type={type}
      multiline={multiline}
      rows={lines}
      autoFocus={autoFocus}
      fullWidth
      margin="normal"
      placeholder={placeholder}
      helperText={errorText}
      error={!!errorText}
      inputProps={inputProps}
      {...field}
      {...variantProps}
    />
  );
};
